import React, { useState, useEffect } from 'react';
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzIcon, BringzzText } from "@bringzz/components";
import useRequest from 'hooks/useRequest';

const PaymentMethodsPage = () => {
    const { backPress, navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();

    const [cardData, setCardData] = useState(null);

    useEffect(() => {
        const fetchCardData = async () => {
            try {
                const response = await sendRequest({
                    method: 'POST',
                    url: `module/getVirtualCardInfo/payment`,
                    data: {}
                });
                
                if (response.status === 'success') {
                    let cardNumberAsArray = String(response.data.card.number).split('');
                    cardNumberAsArray.splice(4, 0, ' ');
                    cardNumberAsArray.splice(9, 0, ' ');
                    cardNumberAsArray.splice(14, 0, ' ');
                    cardNumberAsArray = cardNumberAsArray.join('');
                    setCardData({
                        cardNumber: cardNumberAsArray,
                        expirationDate: (response.data.card.exp_month < 10 ? '0' + response.data.card.exp_month : response.data.card.exp_month) + '/' + String(response.data.card.exp_year).slice(-2),
                        cvv: response.data.card.cvc,
                        cardHolder: response.data.card.cardholder,
                        brand: response.data.card.brand.toUpperCase(),
                        status: response.data.card.status
                    });
                }
            } catch (error) {
                console.error(error);
            }
        };
        
        fetchCardData();
    }, []);

    if(loading) {
        return <div className='flex items-center justify-center h-full w-full'>
           <div 
            className={`w-10 h-10 animate-spin rounded-full border-4 border-gray-200`}
            style={{ borderTopColor: '#b080f7' }}
            >
            </div>
        </div>
    }

    if (!cardData) {
        return <div className='flex items-center justify-center h-full w-full'>
            <BringzzText tag='h4' className='text-center font-thin'>
                You don&apos;t have an issued virtual credit card yet.
            </BringzzText>
        </div>
    }

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer text-gray-700"
                    onClick={backPress}
                />,
                title: <BringzzText tag='h2' className="font-semibold text-gray-900">Payment Methods</BringzzText>
            }}
        >
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-6">
                <div className="max-w-md mx-auto">
                    <div className="relative mb-8">
                        <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-2xl p-6 text-white shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-300">
                            <div className="flex justify-between items-start mb-8">
                                <div className="px-3 py-1 bg-white/20 rounded backdrop-blur-sm flex items-center justify-center">{cardData.brand || 'VISA'}</div>
                                <div className="text-right">
                                    <div className="text-xs opacity-80">VALID THRU</div>
                                    <div className="font-mono text-sm">
                                        {cardData.expirationDate || 'MM/YY'}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="font-mono text-xl tracking-wider mb-6">
                                {cardData.cardNumber || '•••• •••• •••• ••••'}
                            </div>
                            
                            <div className="flex justify-between items-end">
                                <div>
                                    <div className="text-xs opacity-80 mb-1">CARDHOLDER</div>
                                    <div className="font-medium text-sm uppercase">
                                        {cardData.cardHolder || 'YOUR NAME'}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="px-2 py-1 bg-white/30 rounded-sm text-xs flex items-center justify-center">{cardData.status || ''}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                        <div className="space-y-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-3">
                                    Card number
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        disabled
                                        value={cardData.cardNumber}
                                        className={`w-full px-3 py-2 border-2 rounded-lg font-mono text-sm transition-all duration-200 focus:outline-none focus:ring-0 border-gray-200 focus:border-indigo-500 bg-gray-50 focus:bg-white`}
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                                        <div className="px-2 py-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded flex items-center justify-center text-xs text-white">{cardData.brand || 'VISA'}</div>
                                    </div>
                                </div>
                                
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-3">
                                        Expiration date
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={cardData.expirationDate}
                                        className={`w-full px-3 py-2 border-2 rounded-lg font-mono text-sm transition-all duration-200 focus:outline-none focus:ring-0 border-gray-200 focus:border-indigo-500 bg-gray-50 focus:bg-white`}
                                    />
                                    
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-3">
                                        CVV
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={cardData.cvv}
                                        className={`w-full px-3 py-2 border-2 rounded-lg font-mono text-sm transition-all duration-200 focus:outline-none focus:ring-0 border-gray-200 focus:border-indigo-500 bg-gray-50 focus:bg-white`}
                                    />
                                    
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-3">
                                    Cardholder name
                                </label>
                                <input
                                    type="text"
                                    disabled
                                    value={cardData.cardHolder}
                                    className={`w-full px-3 py-2 border-2 rounded-lg text-sm transition-all duration-200 focus:outline-none focus:ring-0 border-gray-200 focus:border-indigo-500 bg-gray-50 focus:bg-white`}
                                />
                                
                            </div>
                        </div>

                        <div className="mt-8 p-4 bg-green-50 border border-green-200 rounded-xl">
                            <div className="flex items-center space-x-3">
                                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                                    <div className="w-3 h-3 border-2 border-white rounded-full"></div>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-green-800">
                                        Your payment information is encrypted and secure
                                    </p>
                                    <p className="text-xs text-green-600 mt-1">
                                        We use industry-standard security measures to protect your data
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default PaymentMethodsPage;